import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { SelectItem } from './select-item';

@Component({
  selector: 'app-custom-select',
  templateUrl: './custom-select.component.html',
  styleUrls: ['./custom-select.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomSelectComponent {
  label?: string;
  @Input() selectLabel: string = ''
  @Input() data: SelectItem<any>[] = [];

  @Input() selected?: SelectItem<any>;
  @Output() selectedChange = new EventEmitter<SelectItem<any>>();

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selected) {
      if (!this.selected) {
        //select first element of data
        this.label = this.data[0].label;
      } else {
        this.label = this.selected.label;
      }
    }
  }

  reset() {
    this.label = this.data[0].label;
    this.selected = this.data[0];
  }

  change(select: SelectItem<any>) {
    this.label = select.label;
    this.selected = select;
    this.selectedChange.emit(this.selected);
  }
}
